<script setup lang="ts">
import { ref, onMounted } from 'vue'

const isDark = ref(false)

/** Apply or remove the `dark` class on the <html> element to switch themes. */
const setTheme = (dark: boolean) => {
  const html = document.documentElement
  if (dark) {
    html.classList.add('dark')
  } else {
    html.classList.remove('dark')
  }
}

/** Toggle dark mode and persist the choice in localStorage. */
const toggleDark = () => {
  isDark.value = !isDark.value
  setTheme(isDark.value)
  localStorage.setItem('theme', isDark.value ? 'dark' : 'light')
}

onMounted(() => {
  const stored = localStorage.getItem('theme')
  if (stored === 'dark') {
    isDark.value = true
    setTheme(true)
  } else {
    // Default to dark and persist the choice
    isDark.value = true
    setTheme(true)
    localStorage.setItem('theme', 'dark')
  }
})
</script>

<template>
  <button
    class="flex items-center justify-center w-10 h-10 rounded-full bg-gray-200 dark:bg-gray-700 text-gray-800 dark:text-gray-100 shadow-md hover:shadow-lg focus:outline-none cursor-pointer"
    @click="toggleDark"
  >
    <!-- Display sun when dark mode is enabled, moon otherwise -->
    <span
      v-if="isDark"
      class="text-base"
    >
      ☀️
    </span>
    <span
      v-else
      class="text-base"
    >
      🌙
    </span>
  </button>
</template>
